import {
  Dialog,
  Portal,
  CloseButton,
  Heading,
  Box,
} from "@chakra-ui/react";
import { colors } from "../../theme";

/**
 * AppModal - Reusable modal component
 * 
 * @param {boolean} isOpen - Whether modal is open
 * @param {function} onClose - Close handler
 * @param {string} title - Modal title
 * @param {string} size - Modal size (sm, md, lg, xl, full)
 * @param {ReactNode} children - Modal content
 * @param {ReactNode} footer - Footer content
 */
const AppModal = ({
  isOpen,
  onClose,
  title,
  size = "md",
  children,
  footer,
  ...rest
}) => {
  const getSizeStyles = () => {
    switch (size) {
      case "sm":
        return { maxW: "400px" };
      case "lg":
        return { maxW: "800px" };
      case "xl":
        return { maxW: "1000px" };
      case "full":
        return { maxW: "100%", mx: 4 };
      case "md":
      default:
        return { maxW: "600px" };
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => !e.open && onClose()}>
      <Portal>
        <Dialog.Backdrop bg="blackAlpha.600" />
        <Dialog.Positioner>
          <Dialog.Content
            bg="white"
            borderRadius="lg"
            boxShadow="xl"
            w="100%"
            {...getSizeStyles()}
            {...rest}
          >
            <Dialog.Header
              borderBottom="1px solid"
              borderColor={colors.disabled}
              px={6}
              py={4}
            >
              <Heading size="md" color={colors.text}>
                {title}
              </Heading>
              <Dialog.CloseTrigger asChild>
                <CloseButton
                  position="absolute"
                  right={4}
                  top={4}
                  size="sm"
                />
              </Dialog.CloseTrigger>
            </Dialog.Header>

            <Dialog.Body px={6} py={4}>
              {children}
            </Dialog.Body>

            {footer && (
              <Dialog.Footer
                borderTop="1px solid"
                borderColor={colors.disabled}
                px={6}
                py={4}
              >
                {footer}
              </Dialog.Footer>
            )}
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default AppModal;
